import React from 'react';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import SelectedShipToAddressLabel from 'src/common/components/selectedShipToAddressLabel/SelectedShipToAddressLabel';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { getDisplayDate } from 'src/utils/dateUtils';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { VISIBLE } from 'src/constants/appConstants';
import { useSelector } from 'react-redux';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';

export const StyledShippingDetails = styled.p`
    margin: 0 !important;
    font-family: AvenirNextWorld Regular;
    font-size: 15px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
}));

const RowTemplateDesktop = ({
    item,
    idx,
    checkboxClickHandler,
    quantityInputChangeHandler,
    countryCode,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { transferRecipientVisibility } = useSelector(
        (state) => state.loginReducer
    );
    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
                marginTop={0}
            >
                <Grid container spacing={3} alignItems={'flex-start'}>
                    <Grid
                        item
                        md={transferRecipientVisibility == VISIBLE ? 3 : 5}
                        sm={transferRecipientVisibility == VISIBLE ? 3 : 5}
                        style={{ display: 'flex' }}
                    >
                        <Checkbox
                            id={`reportUsage-replenishmentRequest-${item.cfn}-checkbox`}
                            checked={item.isSelected}
                            name={item.cfn}
                            onCheckboxSelectionChange={(e) =>
                                checkboxClickHandler(e, item)
                            }
                            disabled={item.isExcludedItem}
                        />
                        <div style={{ paddingLeft: '14px', width: '90%' }}>
                            <TextWithClicks
                                classes={classes}
                                media={{
                                    titleArea: 6,
                                    buttonnsArea: 6,
                                    xs: 3,
                                    lg: 2,
                                }}
                                leftTitle={item.cfn}
                                typeNonTissue={item.salesOrg === 'S002' && 'NT'}
                                typeEA={item.uom}
                                styleObj={{
                                    labelStyle: { padding: '0 0 8px' },
                                    tagsStyle: { padding: '3px 0 0' },
                                }}
                                item={item}
                            />
                            <CustomLabel
                                fWeight={'normal'}
                                fSize={'13px !important'}
                                paddingRight={'2rem !important'}
                                color={'#140F4B'}
                                label={item.description}
                                fontFamily={'AvenirNextWorld Regular'}
                            />
                        </div>
                    </Grid>
                    {item.isExcludedItem ? (
                        <Grid item md={6} sm={6} style={{ display: 'flex' }}>
                            <AlertMsg
                                message={t(
                                    'consignmentBilling.replen.replenListView.replenListViewDesktop.itemCannotBeReplenished'
                                )}
                            />
                        </Grid>
                    ) : (
                        <>
                            <Grid item md={3} sm={3}>
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'100%'}
                                    label={
                                        item.shippingDetails && (
                                            <>
                                                {item.shippingDetails
                                                    .attnLine && (
                                                    <StyledShippingDetails>
                                                        {t(
                                                            'consignmentBilling.replen.replenListView.replenListViewDesktop.attn'
                                                        )}{' '}
                                                        {
                                                            item.shippingDetails
                                                                .attnLine
                                                        }
                                                    </StyledShippingDetails>
                                                )}
                                                {Object.keys(
                                                    item?.shippingDetails
                                                        ?.transferRecipient
                                                ).length > 0 && (
                                                    <StyledShippingDetails>
                                                        {
                                                            item
                                                                ?.shippingDetails
                                                                ?.transferRecipient
                                                                ?.city
                                                        }
                                                    </StyledShippingDetails>
                                                )}
                                                {item.shippingDetails
                                                    .shippingAddress && (
                                                    <StyledShippingDetails>
                                                        <SelectedShipToAddressLabel
                                                            address={
                                                                item
                                                                    .shippingDetails
                                                                    .shippingAddress
                                                            }
                                                        />
                                                    </StyledShippingDetails>
                                                )}
                                                {item?.shippingDetails
                                                    ?.careOfField && (
                                                    <StyledShippingDetails>
                                                        {t(
                                                            'consignmentBilling.replen.replenListView.replenListViewDesktop.Careof'
                                                        )}{' '}
                                                        {
                                                            item
                                                                ?.shippingDetails
                                                                ?.careOfField
                                                        }
                                                    </StyledShippingDetails>
                                                )}
                                            </>
                                        )
                                    }
                                />
                            </Grid>
                            {transferRecipientVisibility == VISIBLE && (
                                <Grid
                                    item
                                    md={
                                        transferRecipientVisibility ==
                                            VISIBLE &&
                                        window.innerWidth === sizes.ipadAir &&
                                        countryCode === COUNTRY_CODE_JAPN
                                            ? 3
                                            : window.innerWidth ===
                                                  sizes.ipadAir &&
                                              countryCode === COUNTRY_CODE_JAPN
                                            ? 2
                                            : 3
                                    }
                                    sm={
                                        window.innerWidth === sizes.ipadAir &&
                                        countryCode === COUNTRY_CODE_JAPN
                                            ? 2
                                            : 3
                                    }
                                    style={{
                                        width:
                                            window.innerWidth ===
                                                sizes.ipadAir &&
                                            countryCode === COUNTRY_CODE_JAPN
                                                ? '30%'
                                                : '',
                                    }}
                                >
                                    <CustomLabel
                                        fSize={'15px !important'}
                                        color={'#202124'}
                                        letterSpacing={'0px !important'}
                                        fWeight={'normal !important'}
                                        maxWidth={'100%'}
                                        label={
                                            item?.shippingDetails
                                                ?.transferRecipient && (
                                                <>
                                                    {Object.keys(
                                                        item?.shippingDetails
                                                            ?.transferRecipient
                                                    ).length > 0 && (
                                                        <StyledShippingDetails>
                                                            <SelectedShipToAddressLabel
                                                                address={
                                                                    item
                                                                        ?.shippingDetails
                                                                        ?.transferRecipient
                                                                }
                                                            />
                                                        </StyledShippingDetails>
                                                    )}
                                                </>
                                            )
                                        }
                                    />
                                </Grid>
                            )}
                            <Grid
                                item
                                md={
                                    transferRecipientVisibility == VISIBLE
                                        ? 2
                                        : 3
                                }
                                sm={
                                    transferRecipientVisibility == VISIBLE
                                        ? 2
                                        : 3
                                }
                            >
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    label={
                                        item.shippingDetails && (
                                            <StyledShippingDetails>
                                                {item.shippingDetails
                                                    .shippingMethod
                                                    ? item.shippingDetails
                                                          .shippingMethod
                                                          .shippingMethodName
                                                    : ''}
                                            </StyledShippingDetails>
                                        )
                                    }
                                />
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    fontFamily={'AvenirNextWorld Regular'}
                                    label={
                                        item?.shippingDetails?.surgeryDate && (
                                            <>
                                                {/* <StyledShippingDetails>
                                                    {t(
                                                        'common.surgeryDateLabel'
                                                    )}
                                                </StyledShippingDetails> */}
                                                <StyledTextDiv
                                                    width={'100%'}
                                                    color={'#3c3c3c'}
                                                    fontSize={'13px'}
                                                    fontWeight={'bold'}
                                                    // marginRight={
                                                    //     isMobileView
                                                    //         ? '50px'
                                                    //         : 'unset'
                                                    // }
                                                    // padding={
                                                    //     isMobileView
                                                    //         ? '13px 0 5px 0'
                                                    //         : 'unset'
                                                    // }
                                                >
                                                    {t(
                                                        'common.surgeryDateLabel'
                                                    )}{' '}
                                                </StyledTextDiv>
                                                <StyledShippingDetails>
                                                    {item?.shippingDetails
                                                        ?.surgeryDate
                                                        ? getDisplayDate(
                                                              item
                                                                  .shippingDetails
                                                                  ?.surgeryDate
                                                          )
                                                        : ''}
                                                </StyledShippingDetails>
                                            </>
                                        )
                                    }
                                />
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    fontFamily={'AvenirNextWorld Regular'}
                                    label={
                                        item?.shippingDetails
                                            ?.requestDeliveryDate && (
                                            <>
                                                <StyledTextDiv
                                                    width={'100%'}
                                                    color={'#3c3c3c'}
                                                    fontSize={'13px'}
                                                    fontWeight={'bold'}
                                                    // marginRight={
                                                    //     isMobileView
                                                    //         ? '50px'
                                                    //         : 'unset'
                                                    // }
                                                    // padding={
                                                    //     isMobileView
                                                    //         ? '13px 0 5px 0'
                                                    //         : 'unset'
                                                    // }
                                                >
                                                    {t(
                                                        'consignmentBilling.replen.replenListView.replenListViewMobile.requestedDelivery'
                                                    )}{' '}
                                                    {t('announcements.date')}{' '}
                                                </StyledTextDiv>
                                                {/* <StyledShippingDetails></StyledShippingDetails> */}
                                                <StyledShippingDetails>
                                                    {item?.shippingDetails
                                                        ?.requestDeliveryDate
                                                        ? getDisplayDate(
                                                              item
                                                                  .shippingDetails
                                                                  ?.requestDeliveryDate
                                                          )
                                                        : ''}
                                                </StyledShippingDetails>
                                            </>
                                        )
                                    }
                                />
                                {/* {item?.shippingDetails?.requestDeliveryDate && (
                                    <MainContainerItems
                                        padding={true}
                                        marginTop={'20px'}
                                            width={'100%'}
                                             color={'#202124'}
                                    >
                                        <Title
                                            showAstrisk={false}
                                             color={'#202124'}
                                        >
                                            (Requested Delivery
                                        </Title>
                                        <Subtitle flexDirection="row">
                                            Date: 
                                        </Subtitle>
                                    </MainContainerItems>
                                )} */}
                            </Grid>
                            <Grid
                                item
                                md={
                                    window.innerWidth === sizes.ipadAir &&
                                    countryCode === COUNTRY_CODE_JAPN
                                        ? ''
                                        : item?.shippingDetails
                                              ?.transferRecipient
                                        ? 1
                                        : 1
                                }
                                sm={
                                    window.innerWidth === sizes.ipadAir &&
                                    countryCode === COUNTRY_CODE_JAPN
                                        ? ''
                                        : item?.shippingDetails
                                              ?.transferRecipient
                                        ? 1
                                        : 1
                                }
                                style={{
                                    width:
                                        transferRecipientVisibility ==
                                            VISIBLE &&
                                        window.innerWidth === sizes.ipadAir &&
                                        countryCode === COUNTRY_CODE_JAPN
                                            ? '0%'
                                            : window.innerWidth ===
                                                  sizes.ipadAir &&
                                              countryCode === COUNTRY_CODE_JAPN
                                            ? '11.66%'
                                            : '',
                                }}
                            >
                                {!item.isExcludedItem && (
                                    <TextWithInputs
                                        placeholder={t(
                                            'consignmentBilling.replen.replenListView.replenListViewMobile.qty'
                                        )}
                                        value={
                                            item.newReplenQty !== undefined
                                                ? item.newReplenQty
                                                : item.replenQty
                                        }
                                        onkeyUp={(e) =>
                                            quantityInputChangeHandler(
                                                e,
                                                idx,
                                                'change'
                                            )
                                        }
                                        onBlurEvent={(e) =>
                                            quantityInputChangeHandler(
                                                e,
                                                idx,
                                                'blur'
                                            )
                                        }
                                        inputBorder={
                                            item.isInvalidReplenQty?.length >
                                                0 && '2px solid #FACFD6'
                                        }
                                        maxLength={3}
                                        inputHeight={'40px'}
                                        inputWidth={'48px'}
                                        alignText={'center'}
                                        errorMsg={item.isInvalidReplenQty}
                                        errorMessageMaxWidth={'100%'}
                                    />
                                )}
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default RowTemplateDesktop;
